import { BrandPipe } from 'app/pipes/brand.pipe';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FuseSharedModule } from '@fuse/shared.module';

import { FooterComponent } from 'app/layout/components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { TermsConditionsDialogModule } from 'app/main/authentication/signup/terms-conditions-dialog/terms-conditions-dialog.module';

@NgModule({
    declarations: [
        FooterComponent
    ],
    imports: [
        RouterModule,

        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatToolbarModule,

        TranslateModule,
        BrandPipe,

        FuseSharedModule,
        TermsConditionsDialogModule,
    ],
    exports: [
        FooterComponent
    ]
})
export class FooterModule {
}
